import { useRoute } from "@/context/router";
import { CompoundButton } from "@fluentui/react-components";
import { AddSquareRegular, ArrowRepeatAllRegular } from "@fluentui/react-icons";
import React from "react";
import { useDraftStyles } from "./styles";

export const Draft = () => {
  const { setCurrentRoute } = useRoute();
  const styles = useDraftStyles();

  const onNewClause = () => {
    setCurrentRoute("revisions/new-clause");
  };

  const onRedraftClause = () => {
    setCurrentRoute("revisions/redraft-clause");
  };

  return (
    <div className={styles.container}>
      <CompoundButton
        onClick={onNewClause}
        appearance="secondary"
        icon={<AddSquareRegular />}
        secondaryContent="Draft a new clause"
      >
        New Clause
      </CompoundButton>
      <CompoundButton
        onClick={onRedraftClause}
        appearance="secondary"
        icon={<ArrowRepeatAllRegular />}
        secondaryContent="Rewrite selected text"
      >
        Redraft Clause
      </CompoundButton>
    </div>
  );
};
